import bag from "./shoppingBag.svg";
import bg1 from "./heroBg1.webp";
import bg2 from "./heroBg2.webp";
import bg3 from "./heroBg3.webp";
import bg4 from "./heroBg4.webp";
import pig from "./pig.avif";
import cheess from "./cheess.webp";
import baconHome from "./baconHome.png";
import bacon from './bacon.avif'
import olives from "./olives.avif";
import olivesHome from "./olivesHome.png";
import cheddar from "./cheddar.avif";
import minus from './minus.svg'
import plus from "./plus.svg";
import parmesan from "./parmesan.avif";
import ricotta from './Ricotta.avif'
import danablu from './Danablu.avif'
import bovarSausages from './bovarSausages.avif'
import salyami from './Salyami.avif'
import bujenina from './Bujenina.avif'
import macarons from './Macarons.avif'
import cakes from './cakes.avif'

export default {
  bag,
  bg1,
  bg2,
  bg3,
  bg4,
  pig,
  cheess,
  bacon,
  baconHome,
  olives,
  olivesHome,
  cheddar,
  plus,
  minus,
  parmesan,
  ricotta,
  danablu,
  bovarSausages,
  salyami,
  bujenina,
  macarons,
  cakes,
};
